export const defaultState = {
  organizations: [],
  selectedOrgId: null,
  myeducatorUsers: [],
  showRemoveModal: false,
  orgDeleteId: null,
  showRemoveCourseModal: false,
  courseDeleteId: null,
  connectedCourses: [],
  selectedCourse: null,
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'UPDATE_ORGANIZATIONS':
      return {
        ...state,
        organizations: action.organizations,
      }
    case 'UPDATE_SELECTED_ORG':
      return {
        ...state,
        selectedOrgId: action.selectedOrgId,
      }
    case 'SHOW_DELETE_ORG':
      return {
        ...state,
        orgDeleteId: action.orgDeleteId,
        showRemoveModal: true,
      }
    case 'HIDE_DELETE_ORG':
      return {
        ...state,
        orgDeleteId: action.orgDeleteId,
        showRemoveModal: false,
      }
    case 'UPDATE_CONNECTED_COURSES':
      return {
        ...state,
        connectedCourses: action.connectedCourses,
      }
    case 'SHOW_DELETE_COURSE':
      return {
        ...state,
        courseDeleteId: action.courseDeleteId,
        showRemoveCourseModal: true,
      }
    case 'HIDE_DELETE_COURSE':
      return {
        ...state,
        courseDeleteId: action.courseDeleteId,
        showRemoveCourseModal: false,
      }
    default:
      return state
  }
}
